import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "TimePanelCompose", webpackPrefetch: true */ './lazyIndex')
);

export const ComposeForm = createLazyComponent(lazyModule, m => m.ComposeForm);

export const lazyShouldShowComposeFormInline = new LazyImport(
    lazyModule,
    m => m.shouldShowComposeFormInline
);

export * from './actions/publicActions';
